import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getInboxRegularizationRequest = createAsyncThunk('inboxRegularization/getRequest', async (data) => {
    try {
        const response = await axios.post('/CorrectionInAttendance/get-request', data, {
            headers: { 'Content-Type': 'application/json' }
        });

        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateInboxRegularizationRemarks = createAsyncThunk('inboxRegularization/updateRemarks', async (data) => {
    try {
        const response = await axios.put('/CorrectionInAttendance/request-status/' + data?.id, data?.data, {
            headers: { 'Content-Type': 'application/json' }
        });

        toast.success(response?.data?.message || 'Status updated successfully.');
        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

const inboxRegularizationSlice = createSlice({
    name: 'inboxRegularization',
    initialState: {
        regularization: []
    },
    reducers: {
        removeInboxRegularization: (state) => {
            state.regularization = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInboxRegularizationRequest.fulfilled, (state, action) => {
            state.regularization = action?.payload;
        });
    }
});

export const { removeInboxRegularization } = inboxRegularizationSlice.actions;
export default inboxRegularizationSlice.reducer;
